
import React from 'react';
import { Table } from '@/components/ui/table';
import DesktopLeadTableHeader from './DesktopLeadTableHeader';
import { calculateTotalMinWidth } from './utils/tableUtils';

interface LeadTableHeaderWrapperProps {
  columnStyles: {
    toggle: string;
    name: string;
    phone: string;
    status: string;
    outcome: string;
    value: string;
    date: string;
  };
}

const LeadTableHeaderWrapper: React.FC<LeadTableHeaderWrapperProps> = ({ columnStyles }) => {
  // Get the total minimum width from our utility
  const totalMinWidth = calculateTotalMinWidth();
  
  return (
    <div className="sticky top-0 z-10 bg-white border-b">
      <div style={{ minWidth: `${totalMinWidth}px` }}>
        <Table className="table-fixed w-full">
          <DesktopLeadTableHeader columnStyles={columnStyles} />
        </Table>
      </div>
    </div>
  );
};

export default LeadTableHeaderWrapper;
